import { RouteType } from "types/RouteType";
import ChangeOrderWorkflowStore from "./ChangeOrderWorkflowStore";

const ChangeOrderWorkflowRoute: RouteType = {
  name: "Change Order Workflow",
  path: "/workflows/change-order",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Change Order Management",
      component: () => import("./ChangeOrderWorkflowHeader"),
      enableRefreshButton: true,
      enableBackButton: false,
    },
    body: {
      component: () => import("./ChangeOrderWorkflow"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    if (!rootStore.changeOrderWorkflowStore) {
      rootStore.changeOrderWorkflowStore = new ChangeOrderWorkflowStore(
        rootStore
      );
    }
    const store = rootStore.changeOrderWorkflowStore as ChangeOrderWorkflowStore;
    await store.loadInitialData();
    return true;
  },
};

export default ChangeOrderWorkflowRoute;